"use client";

import { useTranslations } from "next-intl";
import {
	FaAward,
	FaHeadSideVirus,
	FaTruckMoving,
	FaHandHoldingWater,
	FaHandshake,
} from "react-icons/fa";

const pillarKeys = [
	{ key: "reliability", icon: FaAward },
	{ key: "innovation", icon: FaHeadSideVirus },
	{ key: "delivery", icon: FaTruckMoving },
	{ key: "responsibility", icon: FaHandHoldingWater },
	{ key: "commitment", icon: FaHandshake },
] as const;

export default function PillarsSection() {
	const t = useTranslations("Pillars");

	return (
		<section className="py-20 text-center bg-white">
			<div className="w-full section-padding">
				<h3 className="text-[2.8rem] font-normal text-black mb-2">
					{t("title")}
				</h3>
				<p className="text-[1.8rem] text-black mb-12">{t("subtitle")}</p>
				<div className="flex flex-wrap justify-between gap-8 mt-[7rem]">
					{pillarKeys.map(({ key, icon: Icon }) => (
						<div
							key={key}
							className="flex-1 min-w-[32rem] max-w-full px-6 py-4 flex flex-col items-center text-center"
						>
							<div className="text-[gold] drop-shadow-[0.2rem_0.2rem_#ff0000] text-[6.4rem] mb-4">
								<Icon className="inline-block" />
							</div>
							<p className="text-[1.8rem] font-medium text-black mb-2">
								{t(key)}
							</p>
							<p className="text-[1.6rem] text-black">{t(`${key}Desc`)}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
